import { render, staticRenderFns } from "./no-smoking.vue?vue&type=template&id=708da0b2&scoped=true"
import script from "./no-smoking.vue?vue&type=script&lang=js"
export * from "./no-smoking.vue?vue&type=script&lang=js"
import style0 from "./no-smoking.vue?vue&type=style&index=0&id=708da0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708da0b2",
  null
  
)

export default component.exports